// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1VXnu","consentsList":"PatientConsents_consentsList__3upL-","consentsListEmpty":"PatientConsents_consentsListEmpty__2Brwv"};